import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { useModal } from '../../../../../store/ModalProvider';
import CustomButton from '../../CustomButton/CustomButton';
import type { VehicleWorkshopModalData } from '../../../../../types/modal';

const CustomModalVehicleWorkshop: React.FC = () => {
  const { isOpen, closeModal, modalData, modalHandlers } = useModal();
  const workshopData = modalData as VehicleWorkshopModalData | undefined;
  const [handleViewServices, handleNext] = modalHandlers ?? [];

  if (!workshopData) {
    return null;
  }

  const message =
    workshopData.message ??
    `A Viatura ${workshopData.vehicleCode} encontra-se agora em Oficina. Retifique os Serviços (${workshopData.servicesCount}) nos quais a mesma está escalada.`;

  const handleClose = () => {
    if (typeof handleNext === 'function') {
      handleNext(workshopData);
      return;
    }
    closeModal();
  };

  const handleViewClick = () => {
    if (typeof handleViewServices === 'function') {
      handleViewServices(workshopData);
    }
    closeModal();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      sx={{ pointerEvents: 'auto', zIndex: 2000 }}
      PaperProps={{
        sx: {
          width: 'min(444px, 100%)',
          borderRadius: '4px',
          backgroundColor: '#FFFFFF',
          boxShadow:
            '0 6px 30px 5px rgba(9, 32, 86, 0.12), 0 16px 24px 2px rgba(9, 32, 86, 0.14), 0 8px 10px -5px rgba(9, 32, 86, 0.2)',
          overflow: 'hidden',
          zIndex: 2001,
        },
      }}
    >
      <Box
        sx={{
          background:
            'linear-gradient(180deg, rgba(255, 92, 0, 0.1) 0%, rgba(255, 92, 0, 0) 100%)',
          paddingTop: '16px',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '16px',
              borderRadius: '999px',
              background:
                'linear-gradient(92.92deg, #FF5C00 0.42%, #EDBF67 99.58%)',
            }}
          >
            <WarningAmberRoundedIcon sx={{ fontSize: 35, color: '#FFFFFF' }} />
          </Box>
        </Box>
        <Box sx={{ padding: '16px 24px' }}>
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '16px',
              fontWeight: 600,
              lineHeight: 1.75,
              letterSpacing: '0.15px',
              color: '#092056',
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
            padding: '8px',
          }}
        >
          <CustomButton
            variant="text"
            color="primary"
            onClick={handleViewClick}
            sx={{
              padding: '6px 8px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '24px',
              textTransform: 'none',
              color: '#00A5FF',
            }}
          >
            Ver Serviços
          </CustomButton>
          <CustomButton
            variant="contained"
            onClick={handleClose}
            sx={{
              padding: '6px 16px',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '24px',
              textTransform: 'none',
              background: '#092056',
              color: '#FFFFFF',
              '&:hover': {
                background: '#08204F',
              },
            }}
          >
            Compreendi
          </CustomButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default CustomModalVehicleWorkshop;
